<template>
  <DBox
    :id="'cmp-catalog-projects-sidewindow-related_tracks'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="$t('related_tracks')"
  >
    <NTable
      id="catalog-projects-sidewindow-related_tracks-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('tracks_title')">
            <span
              @click.stop="e => onSelectProduct(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['title']"
            >
              {{ item["title"] }}
            </span>
          </td>
          <td v-bind="tdcon('artist')">
            <span class="txtov" :title="item['artist']">
              {{ item["artist"] }}
            </span>
          </td>
          <td v-bind="tdcon('isrc')">
            <span class="txtov" :title="item['isrc']">
              {{ item["isrc"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedProjectDetails"],
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true,
        showHeader: false
      })
    };
  },
  computed: {
    list: function() {
      return this.selectedProjectDetails.project_tracks || [];
    },
    headers: function() {
      return [
        createTableHeader("tracks_title", { f: 1.5 }),
        createTableHeader("artist"),
        createTableHeader("isrc")
      ];
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }, item) {
      console.log("payload ", { name, value, item });
      this.$emit("changed", { name, value, item });
    },

    onSelectProduct: function(selectedCatalog) {
      console.log("id ", selectedCatalog);
      this.$emit("selected", selectedCatalog.track_id);
    }
  }
};
</script>
